// extracted by mini-css-extract-plugin
export var addressFields = "_og-0";
export var animationContainer = "_og-1";
export var footer = "_og-2";
export var lineItems = "_og-3";
export var modalContent = "_og-4";
export var orderName = "_og-5";
export var strong = "_og-6";
export var warning = "_og-7";